import { TProductParams } from 'feature/appeals/type'
import { FC } from 'react'
import { Controller, useFormContext } from 'react-hook-form'
import { MenuItem, SelectDropdown } from 'ui'
import { ProductParamsIcon } from 'widget/ProductParamsIcon/ProductParamsIcon'

import style from './InputDropdown.module.scss'
interface IInputDropdown {
  parameter: TProductParams
}

// параметр продукта с типом dropdown

export const InputDropdown: FC<IInputDropdown> = ({ parameter }) => {
  const { control } = useFormContext()
  const { name, id, parameterValue, answerList, typeValues, iconUrl } =
    parameter

  return (
    <Controller
      name={`${id}`}
      control={control}
      defaultValue={parameterValue?.value || ''}
      render={({ field }) => (
        <div className={style.inputTextWithIcon}>
          <ProductParamsIcon url={iconUrl} name={name} />
          <SelectDropdown
            selectProps={{
              ...field,
              label: name,
            }}
            formControlProps={{ sx: { minWidth: '100%' } }}
          >
            {answerList?.map(item => (
              <MenuItem value={item.id} key={item.value}>
                {item.value}
              </MenuItem>
            ))}
            {typeValues?.map(item => (
              <MenuItem value={item.id} key={item.value}>
                {item.value}
              </MenuItem>
            ))}
          </SelectDropdown>
        </div>
      )}
    />
  )
}
